import { isEmpty } from 'lodash';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getContestFieldApi } from '../api/adserver';
import { RootState } from './rootReducer';
import { AppThunk } from './store';

interface ContestState {
  loading: boolean;
  isSucess: boolean;
  errMsg: string | null;
  data: any | null;
}

const initialState: ContestState = {
  loading: true,
  isSucess: false,
  errMsg: null,
  data: null,
};

const contestSlice = createSlice({
  name: 'Contest',
  initialState,
  reducers: {
    fetchContestProcessing(state) {
      return { ...state, loading: true };
    },
    fetchContestSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        isSucess: true,
        errMsg: null,
      };
    },
    fetchContestFailed(state, action: PayloadAction<string>) {
      return { ...state, loading: false, errMsg: action.payload, data: null };
    },
  },
});

export const {
  fetchContestProcessing,
  fetchContestSuccess,
  fetchContestFailed,
} = contestSlice.actions;

export const selectContest = createSelector(
  (state: RootState) => state.contest,
  (ContestState: ContestState) => {
    return {
      ...ContestState,
    };
  },
);

export const getContest =
  (corpName: string): AppThunk =>
  async (dispatch) => {
    console.log(`get contest:${corpName}`);
    try {
      dispatch(fetchContestProcessing());
      const data = await getContestFieldApi(corpName);
      if (!isEmpty(data)) {
        dispatch(fetchContestSuccess(data[0]));
      } else {
        dispatch(fetchContestSuccess(null));
      }
    } catch (err: any) {
      dispatch(fetchContestFailed(err.toString()));
    }
  };

export default contestSlice.reducer;
